import * as React from "react"
import { FieldError, useFormContext } from "react-hook-form"
import { Flex, FormControl, InputGroup, Select as CSelect, SelectProps } from "@chakra-ui/react"

import { InlineInputError, InputError } from "./InputError"
import { InlineInputLabel, InputLabel } from "./InputLabel"

interface Props extends SelectProps {
  name: string
  options: any[]
  label?: string
  subLabel?: string
  helpText?: string
}

export const Select = ({ label, subLabel, helpText, placeholder, ...props }: Props) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()
  const fieldError = errors?.[props.name] as FieldError | string
  const registration = register(props.name)

  return (
    <FormControl isInvalid={!!fieldError} isRequired={props.isRequired}>
      <InputLabel label={label} subLabel={subLabel} helpText={helpText} name={props.name} />
      <InputGroup>
        <CSelect
          id={props.name}
          {...registration}
          {...props}
          onChange={(e) => {
            registration.onChange(e)
            props.onChange?.(e)
          }}
          mb={0}
          aria-label={label ? `${label} select` : undefined}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {props.options.map((option, index) => (
            <option
              key={index}
              value={typeof option === "string" || typeof option === "number" ? option : option.value}
            >
              {typeof option === "string" || typeof option === "number" ? option : option.label}
            </option>
          ))}
        </CSelect>
      </InputGroup>
      <InputError error={fieldError} />
    </FormControl>
  )
}
export const InlineSelect = ({ label, subLabel, placeholder, ...props }: Props) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()
  const fieldError = errors?.[props.name] as FieldError | string
  const registration = register(props.name)

  return (
    <FormControl isInvalid={!!fieldError} isRequired={props.isRequired}>
      <Flex align="center">
        <InlineInputLabel label={label} subLabel={subLabel} name={props.name} />

        <CSelect
          id={props.name}
          {...registration}
          variant="outline"
          {...props}
          onChange={(e) => {
            registration.onChange(e)
            props.onChange?.(e)
          }}
          mb={0}
          size="sm"
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {props.options.map((option, index) => (
            <option
              key={index}
              value={typeof option === "string" || typeof option === "number" ? option : option.value}
            >
              {typeof option === "string" || typeof option === "number" ? option : option.label}
            </option>
          ))}
        </CSelect>
      </Flex>
      <InlineInputError error={fieldError} />
    </FormControl>
  )
}
